export default "__VITE_ASSET__DoW4vhFe__"